export const COMPANY_NAMES = {
	'637bb91a71244b0e1e787390': 'EEA SpK',
	'637bb93171244b0e1e787394': 'EEA SpK',
	'63a1ce053ae04e5e1e29263f': 'Lingua',
};

export const GOOD_CALLING_THRESHOLD = 90;
